module.exports = __webpack_public_path__ + "img/logo-dreamocean.927e56a4.webp";